<template>
<div class="shopMobCouponSetting box-shadow">
    <div class="setting form dialog-form" v-show="selectCom.name === 'coupon'">
        <div class="settingHeader"><span>{{item.label}}</span><el-button type="text">查看教程</el-button></div>
        <el-form :model="item" :rules="rules" ref="formName" label-width="100px" class="demo-ruleForm" label-position="left" size="mini">
            <el-form-item label="数据来源" class="no-margin">
                <el-radio-group v-model="item.datasource" @change="setDataSourse">
                    <el-radio :label="1">自动获取</el-radio>
                    <el-radio :label="2">手动选择</el-radio>
                </el-radio-group>
                <div class="content" v-if="item.datasource==2">
                    <div class="el-upload__tip operateBar">
                        <el-button plain type="primary" @click="openShopDialog">增加优惠券</el-button>
                        <div class="tip">最多可添加10张优惠券，拖动选中的优惠券</div>
                    </div>
                    <SlickList lockAxis="y" v-model="item.datalist" :distance="5" :lockToContainerEdges="true" class="model-slickList">
                        <SlickItem v-for="(obj, index) in datalist" :index="index"  :key="index" class="model-slickItem">
                            <div class="model-itemBox">
                                <div class="data-list">
                                    <span class="text-ellipse data-name">{{obj.objectname}}</span>
                                    <span class="text-ellipse data-name">{{obj.usescopetype | usescopetype}}</span>
                                    <span>{{obj.requireprice}}</span>
                                </div>
                                <div class="model-compBtn">
                                    <span class="el-icon-error delComp cursor operateComp" @click.stop="compDel(index)"></span>
                                </div>
                            </div>
                        </SlickItem>
                    </SlickList>
                </div>
                <div class="content" v-if="item.datasource==1">
                    <div class="el-upload__tip">
                        <div class="tip">
                            <span>劵显示数</span>
                            <el-input-number v-model="item.datacount" controls-position="right" :min="1" :max="10" @click.native="getCouponList"></el-input-number>
                        </div>
                    </div>
                    <div class="el-upload__tip">系统自动获取有效的优惠券，最多可添加10张，新创建的券排在前面</div>
                </div>
            </el-form-item>
            <el-form-item label="更多设置" class="no-margin">
                <div class="el-upload__tip operateBar">
                    <el-checkbox v-model="item.isdisplayall" @change="filterDatalist">显示已抢完的劵</el-checkbox>
                    <span>勾选后不显示已抢完的优惠券</span>
                </div>
                <div class="el-upload__tip operateBar">当页面无可显示的优惠券时，优惠券区块将隐</div>
            </el-form-item>
        </el-form>
    </div>
    <coupon ref="coupon" @setCoupon="setCouponList"></coupon>
</div>
</template>

<script>
import {SlickList, SlickItem} from 'vue-slicksort'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
import {getCouponVoucherList} from 'api/api'
import Coupon from 'views/shopMgt/mob/page/dataComponents/coupon'
export default {
    name: 'shopMobCouponSetting',
    data() {
        return {
            isVisited: false,
            item: {
                cominnerid: '',
                label: '优惠券',
                comtype: 'coupon',
                isdisplaytitle: 1,
                titlename: '',
                isdisplayall: 1,
                datasource: 1,
                liststyle: 'detail',
                tagname: '',
                taginnerid: '',
                datacount: 2,
                datalist: []
            },
            rules: {},
            datalist: []
        }
    },
    mounted() {
        this.datalist = []
        this.item = $.extend(true, {}, this.shopMob[this.selectCom.index])
        // if (this.item.datasource === 1 && !this.item.datalist.length && this.$route.query.model !== '1') {
        //     this._getCouponVoucherList()
        // }
    },
    methods: {
        setCouponList(datalist) {
            this.datalist = datalist
            this.filterDatalist()
        },
        openShopDialog() {
            this.$refs.coupon.openDialog(this.item.datalist)
        },
        filterDatalist() {
            if (!this.item.isdisplayall) {
                this.item.datalist = []
                this.datalist.forEach(obj => {
                    if (obj.ishave) {
                        this.item.datalist.push(obj)
                    }
                })
            } else {
                this.item.datalist = this.datalist
            }
        },
        setDataSourse() {
            this.datalist = []
            this.item.datalist = []
            if (this.item.datasource === 1) {
                this._getCouponVoucherList()
            }
        },
        getCouponList() {
            this.datalist = []
            this.item.datalist = []
            this._getCouponVoucherList()
        },
        compDel(index) {
            this.item.datalist.splice(index, 1)
        },
        _getCouponVoucherList() {
            this.setLoading(true)
            getCouponVoucherList({
                data: {
                    ispublic: '',
                    subject: '',
                    page: 1,
                    pageSize: this.item.datacount
                },
                success: data => {
                    data.data.forEach(obj => {
                        this.datalist.push({
                            objectid: obj.innerid,
                            objectname: obj.name,
                            price: obj.faceprice,
                            usescopetype: obj.usescopetype,
                            requireprice: obj.facepricetext,
                            ishave: obj.currentgetcount - obj.currentusecount
                        })
                    })
                    this.filterDatalist()
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setShopMob',
            'setLoading'
        ])
    },
    filters: {
        usescopetype: function (value) {
            switch (value) {
            case 1: value = '全部商品'
                break
            case 2: value = '指定商品'
                break
            }
            return value
        }
    },
    watch: {
        item: {
            handler: function() {
                let tmpList = $.extend(true, [], this.shopMob)
                let obj = $.extend(true, {}, this.item)
                if (obj.datasource === 3) {
                    obj.datalist = this.datalist.slice(0, obj.datacount)
                }
                tmpList.splice(this.selectCom.index, 1, obj)
                this.setShopMob(tmpList)
            },
            deep: true
        },
        selectCom: {
            handler: function() {
                this.item = $.extend(true, {}, this.shopMob[this.selectCom.index])
                this.datalist = this.item.datalist
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters([
            'shopMob',
            'selectCom'
        ])
    },
    components: {
        SlickList, SlickItem, Coupon
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.shopMobCouponSetting {
    .form{
        margin: 0;
    }
    position: absolute;
    top:0;
    left: 100%;
    margin-left: 10px;
    margin-top: 0;
    padding: 0 20px;
    .setting{
        .settingHeader{
            color: $tcolor-base;
            height: 40px;
            border-bottom: 1px solid $line;
            @include flexBox(space-between);
        }
    }
    .input .el-form-item__content{
        line-height: 1;
    }
    .el-input-number--mini{
        width: 66px;
        margin: 0 10px;
        .el-input--mini{
            width: 40px;
        }
        .el-input__inner{
            width: 66px;
            padding-right: 35px;
            text-align: left;
        }
    }
    .content{
        border: 1px solid $line;
        min-height: 60px;
        width: 400px;
        padding: 15px 10px;
        background: $bgcolor-white;
        .operateBar{
            margin-bottom: 15px;
            @include flexBox(flex-between);
            .tip{
                margin-left: 10px;
            }
        }
    }
    .model-slickList{
        .model-slickItem{
            cursor: move;
            box-sizing: border-box;
            margin-bottom:10px;
        }
        .model-slickItem:hover{
            box-sizing: border-box;
            background: $bgcolor-lightbase;
            .operateComp{
                display: inline-block;
            }
        }
    }
}
.model-itemBox{
    box-sizing: border-box;
    position: relative;
    font-size: 14px;
    img{
        width: 40px;
        height: 30px;
        display: block;
    }
    .operateComp{
        display: none;
        position: absolute;
        z-index: 100;
        top: -10px;
        font-size: 20px;
    }
    .delComp{
        color: $tcolor-grey;
        left: calc(100% - 10px);
    }
    .data-list{
        @include flexBox(flex-start);
        height: 30px;
        span{
            margin-right: 10px;
        }
        .data-name{
            max-width: 250px;
        }
    }
}
</style>
